import React, { useState } from 'react';
import './TextInput.css';

interface TextInputProps {
  onSubmit: (text: string) => void;
  placeholder?: string;
  disabled?: boolean;
}

const TextInput: React.FC<TextInputProps> = ({ 
  onSubmit, 
  placeholder = "Type a command...", 
  disabled = false 
}) => {
  const [inputValue, setInputValue] = useState('');
  
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    
    // Basic validation to prevent empty submissions
    const trimmedValue = inputValue.trim();
    if (!trimmedValue) return;
    
    // Call the onSubmit callback with the input value
    onSubmit(trimmedValue);
    
    // Clear the input field
    setInputValue('');
  };
  
  return (
    <form className="text-input-form" onSubmit={handleSubmit}>
      <input
        type="text"
        className="text-input"
        value={inputValue}
        onChange={(e) => setInputValue(e.target.value)}
        placeholder={placeholder}
        disabled={disabled}
        aria-label="Command input"
      />
      <button 
        type="submit" 
        className="submit-button"
        disabled={disabled || !inputValue.trim()}
        aria-label="Send command"
      >
        Send
      </button>
    </form>
  );
};

export default TextInput;